import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "helium_cookie_consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => { if (!localStorage.getItem(KEY)) setShow(true); }, []);
  const choose = (value) => { localStorage.setItem(KEY, value); window.dispatchEvent(new Event("helium-consent-change")); setShow(false); };
  if (!show) return null;
  return (
    <div className="fixed bottom-16 lg:bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-2xl" data-testid="cookie-banner">
      <div className="bg-white rounded-2xl border border-gray-200 shadow-2xl p-5 sm:p-6">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#FDF2F4] flex items-center justify-center shrink-0"><Cookie className="w-5 h-5 text-[#E0243A]" /></div>
          <div className="flex-1">
            <h3 className="font-bold text-gray-900">Datenschutz &amp; Cookies</h3>
            <p className="text-sm text-gray-600 mt-1">Wir verwenden nur technisch notwendige Daten (z. B. für Ihre Anmeldung). Optionale Cookies helfen uns, HELIUM zu verbessern. Details in unserer{" "}
              <Link to="/datenschutz" className="text-[#E0243A] font-medium underline">Datenschutzerklärung</Link>.</p>
            <div className="mt-4 flex flex-wrap gap-2">
              <button onClick={() => choose("all")} data-testid="cookie-accept-all" className="bg-[#E0243A] hover:bg-[#C81E33] text-white font-semibold px-5 py-2.5 rounded-xl text-sm">Alle akzeptieren</button>
              <button onClick={() => choose("necessary")} data-testid="cookie-necessary" className="border border-gray-200 hover:bg-gray-50 text-gray-800 font-medium px-5 py-2.5 rounded-xl text-sm">Nur notwendige</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
